import React from "react";

import { twMerge } from "@/design-system/twMerge";

export type BadgeAppearance = "soft" | "outline";

export type BadgeProps = {
  className?: string;
  variant?: keyof typeof variantSoftStyles;
  text: string | React.ReactNode;
  appearance?: BadgeAppearance;
};

const variantSoftStyles = {
  success: "bg-status-success-tint text-status-success",
  warning: "bg-status-warning-tint text-status-warning",
  error: "bg-status-error-tint text-status-error",
  unknown: "bg-surface-hover text-textSubtle",
  info: "bg-status-info-tint text-status-info",
};

const variantOutlineStyles = {
  success: "bg-surface-default text-status-success border-status-success",
  warning: "bg-surface-default text-status-warning border-status-warning",
  error: "bg-surface-default text-status-error border-status-error",
  unknown: "bg-surface-default text-textSubtle border-borderDefault",
  info: "bg-surface-default text-status-info border-status-info",
};

export const Badge = ({
  className,
  variant = "success",
  text,
  appearance = "soft",
}: BadgeProps) => {
  const styles =
    appearance === "outline" ? variantOutlineStyles : variantSoftStyles;
  return (
    <span
      className={twMerge(
        "text-label-xs inline-flex w-fit items-center justify-center rounded-md px-2 py-1",
        appearance === "outline" && "border",
        styles[variant],
        className,
      )}
    >
      {text}
    </span>
  );
};
